import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  { n: "01", title: "Vous nous contactez", text: "Décrivez votre besoin et transmettez des photos si nécessaire." },
  { n: "02", title: "Vous recevez votre devis", text: "Nous évaluons l'intervention et vous proposons une solution adaptée." },
  { n: "03", title: "Nous intervenons", text: "Travail réalisé proprement et efficacement." },
  { n: "04", title: "Vous profitez du résultat", text: "Votre espace est propre et remis en état." },
];

export default function Process() {
  return (
    <section data-testid="process-section" className="py-16 sm:py-24 bg-[#10180f] text-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow light>Comment ça marche</Eyebrow>
          <h2 className="mt-3 font-display font-semibold tracking-tight leading-snug text-2xl sm:text-3xl lg:text-4xl text-cream" data-testid="process-title">
            Simple du début à la fin.
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08}>
              <div data-testid={`process-step-${s.n}`} className="relative">
                <span className="font-mono text-5xl font-medium text-terra/90">{s.n}</span>
                <div className="mt-4 h-px w-full bg-cream/15" />
                <h3 className="mt-5 font-display font-semibold text-lg text-cream">{s.title}</h3>
                <p className="mt-2 text-sm text-cream/65 leading-relaxed">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
